import { render, staticRenderFns } from "./editPwdModal.vue?vue&type=template&id=385edce0&scoped=true&"
import script from "./editPwdModal.vue?vue&type=script&lang=js&"
export * from "./editPwdModal.vue?vue&type=script&lang=js&"
import style0 from "./editPwdModal.vue?vue&type=style&index=0&id=385edce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385edce0",
  null
  
)

export default component.exports